module.exports = __webpack_public_path__ + "media/images/common/ico-btn-favorite-on-1838489482a689fb1347bead6ab1e07d.svg";